import { navigate } from 'gatsby';

import { convertToRelativeUrl, isExternalUrl, isRelativeUrl } from 'src/utils/url';

/**
 * Navigates to a URL using the appropriate method based on URL type.
 * - Relative URLs use Gatsby's navigate
 * - External URLs use window.location.href
 * - Absolute, internal URLs are converted to relative and use Gatsby's navigate
 *
 * @param url - The URL to navigate to
 */
export function universalNavigate(url: string): void {
  if (!url) {
    // eslint-disable-next-line no-console
    console.error('Cannot navigate to falsy URL', url);
    return;
  }

  if (isRelativeUrl(url)) {
    navigate(url);
    return;
  }

  if (isExternalUrl(url)) {
    window.location.href = url;
    return;
  }

  // URL is an absolute, internal URL and needs to be converted to a relative URL
  const relativeUrl = convertToRelativeUrl(url);
  navigate(relativeUrl);
}
